import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { pipe } from 'rxjs';
import { take, tap } from 'rxjs/operators';
import { MmAlertMode, MmAlertService, MmAlertSize, MmAlertType } from '@metromarkets/components';

import { RESET_PASSWORD_SUCCESS_QUERY_PARAM } from '~shared/constants/links.constants';
import { UrlUtil } from '~shared/utils/url.util';
import { NUMBER_1 } from '~shared/constants';
import { ApplicationEventService } from '~shared/modules/application-event/services';
import { AuthorizationApplicationEvent } from '~shared/modules/application-event/models';
import { ApplicationAuthorizationActionType, ResetPasswordLabel } from '~shared/modules/application-event/constants';

@Injectable({
  providedIn: 'root',
})
export class PasswordResetService {
  constructor(
    private readonly router: Router,
    private readonly alertService: MmAlertService,
    private readonly translateService: TranslateService,
    private applicationEventService: ApplicationEventService,
    // eslint-disable-next-line @typescript-eslint/ban-types
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  public resetPasswordSuccessObserver() {
    return pipe(
      tap(() => {
        if (isPlatformBrowser(this.platformId)) {
          const isSuccess = UrlUtil.getQueryParam(RESET_PASSWORD_SUCCESS_QUERY_PARAM) === 'true';
          if (isSuccess) {
            this.applicationEventService.publish(
              new AuthorizationApplicationEvent(
                ApplicationAuthorizationActionType.SetPassword,
                ResetPasswordLabel.Success
              )
            );
            UrlUtil.removeQueryParameters([RESET_PASSWORD_SUCCESS_QUERY_PARAM], this.router);
            this.showResetPasswordSuccessAlert();
          }
        }
      })
    );
  }

  public showResetPasswordEmailSentSuccessAlert() {
    const title = 'REGULAR.RESET_PASSWORD_EMAIL_SENT.SUCCESS.ALERT.TITLE';
    const message = 'REGULAR.RESET_PASSWORD_EMAIL_SENT.SUCCESS.ALERT.MESSAGE';

    this.showAlert(title, message);
  }

  public showResetPasswordEmailSentFailureAlert() {
    const title = 'REGULAR.RESET_PASSWORD.FAILURE.ALERT.TITLE';
    const message = 'REGULAR.RESET_PASSWORD.FAILURE.ALERT.MESSAGE';

    this.showAlert(title, message, MmAlertType.error);
  }

  private showResetPasswordSuccessAlert() {
    const title = 'REGULAR.RESET_PASSWORD.SUCCESS.ALERT.TITLE';
    const message = 'REGULAR.RESET_PASSWORD.SUCCESS.ALERT.MESSAGE';

    this.showAlert(title, message);
  }

  private showAlert(title: string, message: string, type: MmAlertType = MmAlertType.success) {
    this.translateService
      .get([title, message])
      .pipe(take(NUMBER_1))
      .subscribe((translations) => {
        this.alertService.addAlert({
          type,
          title: translations[title],
          message: translations[message],
          mode: MmAlertMode.alert,
          size: MmAlertSize.large,
        });
      });
  }
}
